// Overview Routing

const OVERVIEW_ROUTES = {
	path: "overview",
	children: [{ path: "dashboard", element: <></> }],
};

export default OVERVIEW_ROUTES;
